module.exports = __webpack_public_path__ + "assets/images/notfound_25h-3cd9278c80d535fe1dad186c5198565e.png";